import dataServices from '@/shared/api/dataServices';

import {
  ADD_OFFER,
  DELETE_OFFER,
  GET_OFFERS
} from '../mutation-types';

const state = () => ({
  offers: []
});

const mutations = {
  [ADD_OFFER](state, offer) {
    state.offers.push(offer);
  },
  [DELETE_OFFER](state, offer) {
    state.offers = [...state.offers.filter((b) => b.CS_DATA.OFFER_NO !== offer)];
  },
  [GET_OFFERS](state, offers) {
    state.offers = offers;
  }
};
const actions = {
  async addOfferAction({ commit }, offer) {
    const data = await dataServices.addOffer(offer);
    commit(ADD_OFFER, data);
  },
  async getOffersAction({ commit }) {
    const data = await dataServices.getOffers();
    commit(GET_OFFERS, data);
  },
  async deleteOfferAction({ commit }, offer) {
    const deletedOffer = await dataServices.deleteOffer(offer);
    commit(DELETE_OFFER, deletedOffer.CS_DATA.OFFER_NO);
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
